import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from '../shared/Header';
import { Footer } from '../shared/Footer';
export const PublicLayout = () => {
  return <div className="min-h-screen bg-neutral-light lg:pb-6" data-id="element-147">
      <div className="max-w-screen-2xl mx-auto bg-white lg:rounded-3xl lg:shadow-2xl flex flex-col min-h-[calc(100vh-3rem)]" data-id="element-148">
        <Header data-id="element-149" />
        <main className="flex-grow" data-id="element-150">
          <Outlet data-id="element-151" />
        </main>
        <Footer data-id="element-152" />
      </div>
    </div>;
};